import keyBy from 'lodash/keyBy';
import values from 'lodash/values';
import isEmpty from 'lodash/isEmpty';
import { autoCreateProducts, fetchProducts } from '../feedback-linking.utils';

export default {
    namespaced: true,
    state: {
        map: {},
        error: {},
        fetching: false,
        autoCreatingProducts: false,
        autoCreatingProductsError: {},
        autoCreatingProductsResult: {},
    },
    mutations: {
        setMap (state, { map }) {
            state.map = map;
        },
        setError (state, { error }) {
            state.error = error;
        },
        setFetching (state, { fetching }) {
            state.fetching = fetching;
        },
        setAutoCreatingProducts (state, { autoCreatingProducts }) {
            state.autoCreatingProducts = autoCreatingProducts;
        },
        setAutoCreatingProductsError (state, { autoCreatingProductsError }) {
            state.autoCreatingProductsError = autoCreatingProductsError;
        },
        setAutoCreatingProductsResult (state, { autoCreatingProductsResult }) {
            state.autoCreatingProductsResult = autoCreatingProductsResult;
        },
    },
    actions: {
        loadAll ({ commit, state }, { reFetch = false, vendorUuid } = {}) {
            if (!isEmpty(state.map) && !reFetch) {
                return Promise.resolve();
            }
            if (!vendorUuid) {
                throw new Error('No vendorUuid Given');
            }
            commit('setFetching', { fetching: true });

            return fetchProducts({ vendorUuid })
                .then(({ data: products }) => {
                    commit('setFetching', { fetching: false });
                    commit('setMap', {
                        map: keyBy(products, 'uuid'),
                    });
                })
                .catch((error) => {
                    commit('setFetching', { fetching: false });
                    commit('setError', { error });
                    throw error;
                });
        },
        autoCreateProducts ({ commit }, { productsToCreate, vendorUuid } = {}) {
            commit('setAutoCreatingProducts', { autoCreatingProducts: true });
            if (!productsToCreate) {
                throw new Error('No productsToCreate Given');
            }

            if (!vendorUuid) {
                throw new Error('No vendorUuid Given');
            }

            return autoCreateProducts({ productsToCreate, vendorUuid })
                .then(({ data: autoCreatingProductsResult }) => {
                    commit('setAutoCreatingProducts', {
                        autoCreatingProducts: false,
                    });
                    commit('setAutoCreatingProductsResult', { autoCreatingProductsResult });
                })
                .catch((autoCreatingProductsError) => {
                    commit('setAutoCreatingProducts', {
                        autoCreatingProducts: false,
                    });
                    commit('setAutoCreatingProductsError', { autoCreatingProductsError });
                    throw autoCreatingProductsError;
                });
        },
    },
    getters: {
        unLinkedProductsList: (state) => values(state.map).filter((product) => !product.pendo_application_id),
        productByUuid: (state) => (uuid) => state.map[uuid],
        list: (state) => values(state.map),
    },
};
